export default __webpack_public_path__ + "static/media/CZ-RD513C.37d09397.jpg";